var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Row',{staticClass:"expand-row"},[_c('Table',{attrs:{"columns":_vm.columns8,"data":_vm.row.arr}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }